<template>
    <v-layout justify-center class="ma-8">
        <!-- <v-btn-toggle borderless>
            <v-btn small text icon>
                <v-icon>mdi-undo</v-icon>
            </v-btn>
            <v-btn small text icon>
                <v-icon>mdi-redo</v-icon>
            </v-btn>
        </v-btn-toggle>
        <v-divider vertical width="1px" class="ma-8" /> -->
        <v-btn-toggle borderless>
            <v-btn v-bind="{ disabled: disabled_decrease }" small text icon @click="decreaseZoom">
                <v-icon>mdi-minus</v-icon>
            </v-btn>
            <v-btn v-bind="{ disabled: disabled_increase }" small text icon @click="increaseZoom">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-btn-toggle>
    </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
export default {
    computed: {
        ...mapGetters("employment/form/page", ["disabled_decrease", "disabled_increase"]),
    },
    methods: {
        ...mapMutations("employment/form/page", ["decreaseZoom", "increaseZoom"]),
    },
};
</script>

<style></style>
